import { NgClass } from '@angular/common';
import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-orders-view-toggle',
  standalone: true,
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="inline-flex rounded-lg border border-gray-200 bg-gray-100 p-1">
      <button
        (click)="viewChange.emit('summary')"
        [ngClass]="{
          'bg-white text-gray-900 shadow': currentView() === 'summary',
          'text-gray-600': currentView() !== 'summary',
        }"
        class="flex items-center justify-center gap-2 rounded-md px-4 py-1.5 text-sm font-medium whitespace-nowrap transition"
      >
        <span
          class="material-icons w-4 shrink-0 overflow-hidden text-base leading-none"
          >menu</span
        >
        Summary View
      </button>
      <button
        (click)="viewChange.emit('table')"
        [ngClass]="{
          'bg-white text-gray-900 shadow': currentView() === 'table',
          'text-gray-600': currentView() !== 'table',
        }"
        class="flex items-center justify-center gap-2 rounded-md px-4 py-1.5 text-sm font-medium whitespace-nowrap transition"
      >
        <span
          class="material-icons w-4 shrink-0 overflow-hidden text-base leading-none"
          >table</span
        >
        Table View
      </button>
    </div>
  `,
})
export class OrdersViewToggleComponent {
  currentView = input.required<'summary' | 'table'>();

  viewChange = output<'summary' | 'table'>();
}
